import { useEffect } from 'react';
import { secureConsole, isSecureContext, logSecurityEvent } from '../utils/security';

/**
 * Security Provider Component
 * Initializes security measures when the app starts
 */
const SecurityProvider = ({ children }) => {
  useEffect(() => {
    // Secure console in production
    secureConsole();
    
    // Check if running in secure context (HTTPS)
    if (!isSecureContext() && process.env.NODE_ENV === 'production') {
      logSecurityEvent('insecure_context_detected');
      console.warn('⚠️ App is not running in HTTPS. Some features may be limited.');
    }
    
    // Prevent right-click in production (optional - can be removed if too restrictive)
    // const handleContextMenu = (e) => {
    //   if (process.env.NODE_ENV === 'production') {
    //     e.preventDefault();
    //     return false;
    //   }
    // };
    // document.addEventListener('contextmenu', handleContextMenu);
    
    // Log app initialization
    if (process.env.NODE_ENV === 'development') {
      console.log('🔒 Security initialized');
    }
    
    // Cleanup
    return () => {
      // document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);
  
  return children;
};

export default SecurityProvider;
